import React from 'react';
import { Tooltip } from 'antd';
import { TooltipProps } from 'antd/lib/tooltip';
import './Tooltip.less';

const TTooltip: React.FC<TooltipProps> = ({ children, ...props }) => {
  return (
    <Tooltip
      {...props}
      getPopupContainer={(trigger) => trigger.parentNode as HTMLElement}
    >
      {children}
    </Tooltip>
  );
};

export default TTooltip;
